// extracted by mini-css-extract-plugin
export var buttonContainer = "_8v-1";
export var fontSizeSelect = "_8v-3";
export var formatSelect = "_8v-2";
export var formats = "_8v-4";
export var hidden = "_8v-5";
export var icon = "_8v-6";
export var select = "_8v-0";